<template>
	<div id="about-features" class="row about-stats stats block-1-4 block-m-1-2 block-mob-full" data-aos="fade-up">
		<template v-for="feature in features">
			<div class="col-block stats__col">
				<div class="stats__count" :data-count="feature[1]">0</div>
				<h5 v-html="feature[0]"></h5>
			</div>
		</template>
	</div>
</template>

<script>
	// export
	export default {
		name: 'WidgetFeatures',
		methods: {
			/**
			 * Get current language code.
			 * @return {String} current language
			 */
			languageCurrent: function() {
				return ('undefined' === typeof Cookies.get('language')) ? this.languageDefault : Cookies.get('language');
			}
		},
		computed: {
			features: {
				/**
				 * Get features array.
				 * @return {Array} features array
				 */
				get: function() {
					return this.$store.state.aboutFeatures;
				},

				/**
				 * Update features array.
				 */
				set: function() {
					this.$store.dispatch('aboutFeaturesUpdate', this.languageCurrent());
				}
			}
		},
		created: function() {
			// update features array
			this.$store.dispatch('aboutFeaturesUpdate', this.languageCurrent());
		},
		updated: function() {
			this.$nextTick(function () {
				const $features = $('#about-features');
				const $featuresCounters = $features.find('.stats__count');

				// detect direction
				$features.waypoint({
					handler: function (direction) {
						if ('down' === direction) {
							// loop through counters
							$featuresCounters.each(function () {
								// update value
								$(this).prop('number', $(this).text()).animateNumber({number: $(this).attr('data-count')}, 3000);
							});
						}

						// trigger once only
						this.destroy();
					},
					offset: '90%'
				});
			});
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/widgets/Features.vue